import { render, staticRenderFns } from "./index-sign.mpx?vue&type=template&id=2b7f1b76&scoped=true&isComponent&outputPath=components%2Findex-signd5ca0498%2Findex"
import script from "./index-sign.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex-signd5ca0498%2Findex"
export * from "./index-sign.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex-signd5ca0498%2Findex"
import style0 from "./index-sign.mpx?vue&type=style&index=0&id=2b7f1b76&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22md5ca0498%22%7D&isComponent&outputPath=components%2Findex-signd5ca0498%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f1b76",
  null
  
)

export default component.exports